import axios from "axios";
import {
  getThanksgivingConfigURL,
  saveThanksgivingConfigURL,
} from "../const";

export function getThanksgivingApiError(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  const messageText = err?.response?.data?.message;
  if (typeof messageText === "string") return messageText;
  return err?.message || fallback;
}

/** Flatten nested arrays from API, e.g. [["a","b"]] → ["a","b"] */
function toStringList(value) {
  if (value == null || value === "") return [];

  const flatten = (input) => {
    if (!Array.isArray(input)) {
      const trimmed = String(input ?? "").trim();
      return trimmed ? [trimmed] : [];
    }
    return input.flatMap((item) => flatten(item));
  };

  return flatten(value)
    .map((item) => String(item ?? "").trim())
    .filter(Boolean);
}

export function normalizeThanksgivingConfigItem(item) {
  return {
    interval: item?.interval != null ? String(item.interval).trim() : "",
    ricefIds: toStringList(item?.ricef_ids),
    distributionIds: toStringList(item?.distribution_ids),
    senderEmail: toStringList(item?.sender_email),
    fromDate: item?.from_date || "",
    toDate: item?.to_date || "",
  };
}

export function findThanksgivingConfigByInterval(configs, interval) {
  const target = String(interval ?? "").trim();
  if (!target || !Array.isArray(configs)) return null;
  return configs.find((item) => String(item?.interval ?? "").trim() === target) || null;
}

export function buildThanksgivingPayload({
  ricefIds,
  interval,
  distributionIds,
  senderEmail,
  fromDate,
  toDate,
}) {
  return {
    ricef_ids: toStringList(ricefIds),
    interval: String(interval ?? "").trim(),
    distribution_ids: toStringList(distributionIds),
    sender_email: toStringList(senderEmail),
    from_date: String(fromDate ?? "").trim(),
    to_date: String(toDate ?? "").trim(),
  };
}

export async function fetchThanksgivingSettings(interval) {
  const normalized = String(interval ?? "").trim();
  const { data } = await axios.get(getThanksgivingConfigURL, {
    params: normalized ? { interval: normalized } : undefined,
  });
  if (!Array.isArray(data)) return [];
  return data.map(normalizeThanksgivingConfigItem);
}

export async function saveThanksgivingConfig(config) {
  const payload = buildThanksgivingPayload(config);
  const { data } = await axios.post(saveThanksgivingConfigURL, payload, {
    headers: { "Content-Type": "application/json" },
  });

  if (data?.status && String(data.status).toLowerCase() !== "success") {
    throw new Error(data?.message || "Save failed");
  }
  return data;
}
